/**
 * ZoneManagement Service
 * 구역 관리 비즈니스 로직 계층
 */
import type { Zone } from '../../../services/zoneApi';
import type { ZoneSummaryStats } from '../models/ZoneManagement';

export class ZoneManagementService {
  /**
   * 구역 점유율에 따른 배지 색상 반환
   */
  getStatusBadgeClass(occupancyRate: number): string {
    if (occupancyRate >= 90) return 'bg-red-100 text-red-800';
    if (occupancyRate >= 70) return 'bg-orange-100 text-orange-800';
    if (occupancyRate >= 40) return 'bg-yellow-100 text-yellow-800';
    return 'bg-green-100 text-green-800';
  }

  /**
   * 구역 요약 통계 계산
   */
  calculateSummaryStats(
    zones: Zone[],
    summary: Array<{ total_seats: number; occupied_seats: number }>
  ): ZoneSummaryStats {
    const totalSeats = summary.reduce((sum, zone) => sum + zone.total_seats, 0);
    const occupiedSeats = summary.reduce((sum, zone) => sum + zone.occupied_seats, 0);
    const overallOccupancyRate =
      totalSeats > 0 ? Math.round((occupiedSeats / totalSeats) * 100) : 0;

    return {
      totalZones: zones.length,
      totalSeats,
      occupiedSeats,
      overallOccupancyRate,
    };
  }

  /**
   * 구역 삭제 확인 메시지 생성
   */
  getDeleteConfirmMessage(zoneName: string): string {
    return `"${zoneName}" 구역을 정말 삭제하시겠습니까?\n\n이 작업은 되돌릴 수 없으며, 해당 구역의 모든 좌석도 함께 삭제됩니다.`;
  }

  /**
   * 시간당 요금 계산
   */
  calculateHourlyRate(baseRate: number, surcharge?: number): number {
    return baseRate + (surcharge || 0);
  }

  /**
   * 일일 요금 계산
   */
  calculateDailyRate(baseRate: number, surcharge?: number): number {
    return baseRate + (surcharge || 0);
  }

  /**
   * 추가 요금 적용 여부
   */
  hasSurcharge(hourlySurcharge?: number, dailySurcharge?: number): boolean {
    return !!(hourlySurcharge || dailySurcharge);
  }

  /**
   * 요금 포맷팅
   */
  formatPrice(price: number): string {
    return price.toLocaleString();
  }
}

export const zoneManagementService = new ZoneManagementService();
